(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(wurzel) {
    var form = wurzel.querySelector('[data-lm-form]');
    var track = wurzel.querySelector('[data-lm-track]');
    var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var verhalten = reduziert ? 'auto' : 'smooth';
    var geld = function (c) { return window.SF && SF.geld ? SF.geld(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; };

    /* ---------- Galerie ---------- */
    var slides = track ? [].slice.call(track.querySelectorAll('[data-lm-slide]')) : [];
    var thumbs = [].slice.call(wurzel.querySelectorAll('[data-lm-thumb]'));
    var prev = wurzel.querySelector('[data-lm-prev]'), next = wurzel.querySelector('[data-lm-next]');
    function breite() { return track.clientWidth || 1; }
    function aktuell() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / breite()))); }
    function geheZu(i, weich) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: i * breite(), behavior: weich ? verhalten : 'auto' });
    }
    function stand() {
      var i = aktuell();
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (track) {
      var s0 = Number(track.getAttribute('data-start')) || 1;
      if (s0 > 1) { geheZu(s0 - 1, false); window.addEventListener('load', function () { if (track.scrollLeft < 2) geheZu(s0 - 1, false); }); }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(stand); }, { passive: true });
      window.addEventListener('resize', function () { stand(); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { geheZu(Number(t.getAttribute('data-lm-thumb')), true); }); });
      if (prev) prev.addEventListener('click', function () { geheZu(aktuell() - 1, true); });
      if (next) next.addEventListener('click', function () { geheZu(aktuell() + 1, true); });
      stand();
    }

    /* ---------- Lightbox ---------- */
    var lb = null, letzter = null;
    function lbZu() { if (lb) { lb.remove(); lb = null; document.removeEventListener('keydown', lbTaste); if (letzter) letzter.focus(); } }
    function lbTaste(e) { if (e.key === 'Escape') { e.stopPropagation(); lbZu(); } }
    wurzel.addEventListener('click', function (e) {
      var z = e.target.closest('.lm-zoom'); if (!z) return;
      letzter = z;
      lb = document.createElement('div');
      lb.className = 'lm-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      var bild = document.createElement('img'); bild.src = z.getAttribute('data-src'); bild.alt = '';
      var zu = document.createElement('button'); zu.type = 'button'; zu.className = 'kn kn--icon kn--hell';
      zu.setAttribute('aria-label', form ? (form.getAttribute('data-t-close') || 'Schließen') : 'Schließen');
      zu.innerHTML = window.SF && SF.ico ? SF.ico('zu') : '✕';
      lb.appendChild(bild); lb.appendChild(zu);
      lb.addEventListener('click', lbZu);
      document.body.appendChild(lb);
      document.addEventListener('keydown', lbTaste);
      zu.focus();
    });

    if (!form) return;

    /* ---------- Sorten, Preis, Verfügbarkeit ---------- */
    var daten = [];
    try { daten = JSON.parse(form.querySelector('[data-lm-varianten]').textContent); } catch (x) { daten = []; }
    var idFeld = form.querySelector('[data-lm-id]');
    var cta = form.querySelector('[data-lm-cta]'), ctaText = form.querySelector('[data-lm-cta-text]');
    var preisEl = form.querySelector('[data-lm-preis]'), rabattEl = form.querySelector('[data-lm-rabatt]');
    var metaEl = form.querySelector('[data-lm-meta]');
    var stockPill = form.querySelector('[data-lm-stock-pill]'), stockText = form.querySelector('[data-lm-stock-text]');
    var leiste = wurzel.querySelector('[data-lm-leiste]');
    var tCta = form.getAttribute('data-t-cta'), tAus = form.getAttribute('data-t-aus');
    var tLager = form.getAttribute('data-t-lager'), tLagerAus = form.getAttribute('data-t-lager-aus');
    var sel = [];
    form.querySelectorAll('.lm-grp').forEach(function (g, i) {
      var an = g.querySelector('.lm-swb[aria-pressed="true"]');
      sel[i] = an ? an.getAttribute('data-val') : null;
    });
    var start0 = daten.filter(function (v) { return String(v.id) === idFeld.value; })[0];
    if (start0) start0.o.forEach(function (o, i) { if (sel[i] == null) sel[i] = o; });

    function anwenden() {
      var f = daten.filter(function (v) { return v.o.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
      var frei = !!(f && f.a);
      if (f) {
        idFeld.value = f.id;
        var streich = f.c > f.p;
        preisEl.innerHTML = '<span class="pr' + (streich ? ' deal' : '') + '">' + (streich ? '<s>' + geld(f.c) + '</s>' : '') + '<b>' + geld(f.p) + '</b></span>';
        if (rabattEl) {
          if (streich) { rabattEl.textContent = '−' + Math.round((f.c - f.p) * 100 / f.c) + ' %'; rabattEl.hidden = false; }
          else rabattEl.hidden = true;
        }
        if (metaEl && f.m) metaEl.textContent = f.m;
        if (leiste) { var lp = leiste.querySelector('[data-lm-leiste-preis]'); if (lp) lp.textContent = geld(f.p); }
        if (f.b > 0) geheZu(f.b - 1, true);
        if (window.history && history.replaceState) { var u = new URL(window.location); u.searchParams.set('variant', f.id); history.replaceState({}, '', u); }
      }
      cta.disabled = !frei;
      ctaText.textContent = frei ? tCta : tAus;
      stockText.textContent = frei ? tLager : tLagerAus;
      stockPill.classList.toggle('pill--ok', frei);
      stockPill.classList.toggle('pill--aus', !frei);
      form.setAttribute('data-verfuegbar', frei ? '1' : '0');
    }
    form.querySelectorAll('.lm-grp').forEach(function (g, i) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.lm-swb'); if (!b) return;
        sel[i] = b.getAttribute('data-val');
        g.querySelectorAll('.lm-swb').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var out = g.querySelector('[data-lm-out]'); if (out) out.textContent = b.getAttribute('data-val');
        anwenden();
      });
    });

    /* ---------- Schnellkauf-Leiste (Handy): erscheint, wenn der Kaufknopf aus dem Bild ist ---------- */
    if (leiste && 'IntersectionObserver' in window && cta) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        leiste.classList.toggle('sichtbar', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(cta);
      leiste.querySelector('[data-lm-leiste-btn]').addEventListener('click', function () {
        if (cta.disabled) { cta.scrollIntoView({ behavior: verhalten, block: 'center' }); }
        else if (form.requestSubmit) form.requestSubmit(cta); else form.submit();
      });
    }
  }
  function alle() { document.querySelectorAll('[data-lm-hero]').forEach(function (w) { if (!w.__lm) { w.__lm = 1; start(w); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-mengenstaffel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(w) {
    var karten = [].slice.call(w.querySelectorAll('.lm-stufe'));
    var qty = document.querySelector('[data-lm-qty]');
    if (!karten.length || !qty) return;
    var box = qty.closest('.menge');
    function waehle(k) {
      karten.forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
      var n = Number(k.getAttribute('data-menge')) || 1;
      qty.value = n;
      if (box) [].slice.call(box.querySelectorAll('button[data-d]')).forEach(function (b) {
        var d = Number(b.getAttribute('data-d'));
        b.disabled = (d < 0 && n <= 1) || (d > 0 && n >= 99);
      });
    }
    karten.forEach(function (k) { k.addEventListener('click', function () { waehle(k); }); });
    qty.addEventListener('input', function () {
      var n = String(parseInt(qty.value, 10) || 1);
      karten.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-menge') === n ? 'true' : 'false'); });
    });
    waehle(w.querySelector('.lm-stufe.is-top') || karten[0]);
  }
  function alle() { document.querySelectorAll('[data-lm-staffel]').forEach(function (w) { if (!w.__lm) { w.__lm = 1; start(w); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-passt-dazu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(w) {
    if (w.querySelector('.blatt')) return;
    var url = w.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var d = document.createElement('div'); d.innerHTML = html;
      var neu = d.querySelector('[data-lm-empf]');
      if (neu && neu.querySelector('.blatt')) w.innerHTML = neu.innerHTML;
    }).catch(function () {});
  }
  function alle() { document.querySelectorAll('[data-lm-empf]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-toc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bauen(w) {
    var liste = w.querySelector('[data-toc-liste]');
    liste.textContent = '';
    var n = 0, links = [];
    document.querySelectorAll('[data-toc]').forEach(function (el) {
      var titel = (el.getAttribute('data-toc') || '').trim();
      if (!titel || titel === '−' || titel === '-') return;
      if (!el.id) {
        el.id = 'toc-' + titel.toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }
      n++;
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + el.id; a.textContent = titel;
      li.appendChild(a); liste.appendChild(li); links.push({ a: a, el: el });
    });
    w.hidden = n < 2;
    var d = w.querySelector('details');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
    if (mq && !w.__lmMq) {
      w.__lmMq = 1;
      var z = function () { d.open = !mq.matches; };
      z();
      if (mq.addEventListener) mq.addEventListener('change', z); else if (mq.addListener) mq.addListener(z);
    }
    /* aktiver Abschnitt */
    if ('IntersectionObserver' in window && links.length) {
      var sichtbar = {};
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { sichtbar[e.target.id] = e.isIntersecting; });
        var aktiv = null;
        links.forEach(function (l) { if (!aktiv && sichtbar[l.el.id]) aktiv = l; });
        links.forEach(function (l) { if (l === aktiv) l.a.setAttribute('aria-current', 'true'); else l.a.removeAttribute('aria-current'); });
      }, { rootMargin: '-20% 0px -60% 0px' });
      links.forEach(function (l) { io.observe(l.el); });
    }
  }
  function alle() { document.querySelectorAll('[data-lm-toc]').forEach(bauen); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  /* Im Theme-Editor nach Sektions-Änderungen neu aufbauen */
  document.addEventListener('shopify:section:load', alle);
  document.addEventListener('shopify:section:unload', function () { setTimeout(alle, 50); });
  document.addEventListener('shopify:section:reorder', alle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-zusammen"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(w) {
    var kasten = w.querySelector('[data-lm-bsum]');
    var boxen = [].slice.call(w.querySelectorAll('[data-lm-check]'));
    function neu() {
      var n = 0, s = 0;
      boxen.forEach(function (b) {
        var karte = b.closest('.lm-cc');
        if (karte) karte.classList.toggle('lm-an', b.checked);
        if (b.checked) { n++; s += parseInt(b.getAttribute('data-preis'), 10) || 0; }
      });
      if (!kasten) return;
      var a = kasten.querySelector('[data-lm-anzahl]'), t = kasten.querySelector('[data-lm-summe]'), k = kasten.querySelector('[data-lm-bsum-btn]');
      if (a) a.textContent = n;
      if (t) t.textContent = window.SF && SF.geld ? SF.geld(s) : (s / 100).toFixed(2).replace('.', ',') + ' €';
      if (k) k.disabled = n === 0;
    }
    boxen.forEach(function (b) { b.addEventListener('change', neu); });
    neu();
    if (!kasten) return;
    var knopf = kasten.querySelector('[data-lm-bsum-btn]'), text0 = knopf.textContent;
    knopf.addEventListener('click', function () {
      var ids = boxen.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute('data-variant-id'); });
      if (!ids.length) return;
      knopf.disabled = true; knopf.setAttribute('aria-busy', 'true');
      function fertig() { knopf.removeAttribute('aria-busy'); neu(); }
      function fehler() { fertig(); knopf.textContent = kasten.getAttribute('data-t-fehler'); setTimeout(function () { knopf.textContent = text0; }, 2500); }
      if (window.SF && SF.korb) {
        var kette = Promise.resolve();
        ids.forEach(function (id, i) { kette = kette.then(function () { return SF.korb.add(id, 1, { ohneSchublade: i < ids.length - 1 }); }); });
        kette.then(fertig, fertig);
      } else {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/cart'; }).catch(fehler);
      }
    });
  }
  function alle() { document.querySelectorAll('[data-lm-zusammen]').forEach(function (w) { if (!w.__lm) { w.__lm = 1; start(w); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function binde() {
      var form = document.getElementById('sf-nl-sektion');
      if (!form || form.dataset.gebunden) return;
      form.dataset.gebunden = '1';
      form.addEventListener('submit', function (e) {
        var mail = form.querySelector('input[type=email]');
        var hak = form.querySelector('input[type=checkbox]');
        var out = form.querySelector('.meldung');
        if (!mail || !out) return;
        if (!mail.value || mail.validity.typeMismatch || !mail.checkValidity()) {
          e.preventDefault(); out.className = 'meldung fehler'; out.textContent = out.getAttribute('data-fehler-mail') || ''; mail.focus(); return;
        }
        if (hak && !hak.checked) {
          e.preventDefault(); out.className = 'meldung fehler'; out.textContent = out.getAttribute('data-fehler-einwilligung') || ''; hak.focus();
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', binde); else binde();
    document.addEventListener('shopify:section:load', binde);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-passt-dazu"]) return;
  try {
    
  (function () {
    'use strict';
    function q(s, r) { return (r || document).querySelector(s); }
    function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

    /* ----- Empfehlungen laden ----- */
    function laden(el) {
      if (el.__sfRecs) return; el.__sfRecs = true;
      var url = el.getAttribute('data-url'); if (!url) return;
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neu = q('[data-sf-recs-ziel]', doc);
          if (!neu || !q('.c', neu)) return;
          var ziel = q('[data-sf-recs-ziel]', el); ziel.innerHTML = neu.innerHTML;
          el.hidden = false;
          if (window.sfRegalStatus) window.sfRegalStatus(el);
        })
        .catch(function () { /* ohne Empfehlungen bleibt der Abschnitt weg */ });
    }
    function start() { qa('[data-sf-recs]').forEach(laden); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-produkt"]) return;
  try {
    
  (function () {
    'use strict';
    function q(s, r) { return (r || document).querySelector(s); }
    function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function geld(c) { return (window.SF && window.SF.geld) ? window.SF.geld(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function start(root) {
      if (root.__sfPd) return; root.__sfPd = true;
      var daten, T;
      try { daten = JSON.parse(q('script[data-sf-pd-varianten]', root).textContent); T = JSON.parse(q('script[data-sf-pd-texte]', root).textContent); } catch (e) { return; }
      var schwelle = Number(root.getAttribute('data-schwelle')) || 0;
      var stufen = (root.getAttribute('data-stufen') || '1,2,3,6').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
      var kurz = root.getAttribute('data-kurz') || '';
      var form = q('form[data-sf-kauf]', root), idFeld = q('[data-sf-id]', root), mengeFeld = q('input[name=quantity]', root);
      var gruppen = qa('fieldset[data-sf-option]', root);
      var menge = 1, aktuell = null;

      function gewaehlt() { return gruppen.map(function (g) { var r = q('input:checked', g); return r ? r.value : null; }); }
      function finde(opts) {
        for (var i = 0; i < daten.length; i++) { if (daten[i].o.every(function (x, j) { return x === opts[j]; })) return daten[i]; }
        return null;
      }
      function wertFrei(i, wert, opts) {
        var treffer = daten.filter(function (v) { return v.o[i] === wert && v.o.every(function (x, j) { return j === i || x === opts[j]; }); });
        if (!treffer.length) treffer = daten.filter(function (v) { return v.o[i] === wert; });
        return treffer.some(function (v) { return v.a; });
      }
      function zeigeMedium(id) {
        if (!id) return;
        var treffer = qa('.pd-slide[data-media]', root).filter(function (s) { return s.getAttribute('data-media') === String(id); })[0];
        if (!treffer) return;
        qa('.pd-slide[data-media]', root).forEach(function (s) { s.hidden = s !== treffer; });
        qa('[data-sf-thumb]', root).forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-sf-thumb') === String(id) ? 'true' : 'false'); });
      }
      function rabatt(v) { return v && v.c > v.p ? Math.round((v.c - v.p) * 100 / v.c) : 0; }
      function setz(sel, fn) { qa(sel, root).forEach(fn); }

      function aktualisiere(vonNutzer) {
        var opts = gewaehlt();
        var v = gruppen.length ? finde(opts) : daten[0];
        aktuell = v;
        /* Legende, Verfügbarkeitsmarken */
        gruppen.forEach(function (g, i) {
          var t = q('[data-sf-gewaehlt]', g); if (t) t.textContent = opts[i] || '';
          qa('label.chip', g).forEach(function (l) {
            var r = q('input', l);
            if (wertFrei(i, r.value, opts)) l.removeAttribute('data-aus'); else l.setAttribute('data-aus', '');
          });
        });
        var fehlt = q('[data-sf-fehlt]', root); if (fehlt) fehlt.hidden = !!v;
        var verf = !!(v && v.a);
        if (v) {
          if (idFeld) idFeld.value = v.id;
          var r = rabatt(v);
          setz('[data-sf-preis]', function (e) { e.textContent = geld(v.p); });
          setz('[data-sf-streich]', function (e) { e.hidden = !r; e.textContent = r ? geld(v.c) : ''; });
          setz('[data-sf-rabatt]', function (e) { e.hidden = !r; e.innerHTML = '−' + r + '&nbsp;%'; });
          setz('[data-sf-rabatt-bild]', function (e) { e.hidden = !r; e.innerHTML = '−' + r + '&nbsp;%'; });
          setz('[data-sf-grund]', function (e) { e.hidden = !v.u; e.textContent = v.u ? ' · ' + geld(v.u) + ' / ' + v.ur : ''; });
          if (vonNutzer) {
            zeigeMedium(v.m);
            try {
              var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
              window.history.replaceState(window.history.state, '', u.toString());
            } catch (e) { /* ältere Browser: URL bleibt */ }
          }
        }
        var vp = q('[data-sf-verf]', root);
        if (vp) { vp.className = 'pill ' + (verf ? 'pill--ok pill--punkt' : 'pill--aus'); vp.textContent = verf ? T.verfuegbar : T.nichtVerfuegbar; }
        var nicht = q('[data-sf-nicht]', root); if (nicht) nicht.hidden = verf;
        var mg = q('[data-sf-menge]', root); if (mg) mg.hidden = !verf;
        var kn = q('[data-sf-kaufen]', root);
        if (kn) { kn.disabled = !verf; kn.textContent = verf ? T.inDenKorb + (menge > 1 && v ? ' · ' + geld(v.p * menge) : '') : T.nichtVerfuegbarKnopf; if (!verf) kn.classList.add('kn--voll'); else kn.classList.remove('kn--voll'); }
        /* Mengenstaffel */
        var tb = q('[data-sf-staffel]', root);
        if (tb && v) {
          tb.innerHTML = stufen.map(function (n) {
            var s = v.p * n;
            return '<tr><th scope="row">' + n + ' ×</th><td class="zahl">' + esc(geld(v.p)) + '</td><td class="r zahl">' + esc(geld(s)) + (schwelle && s >= schwelle ? ' <span class="pill pill--ok pill--punkt pd-frei">' + esc(T.frei) + '</span>' : '') + '</td></tr>';
          }).join('');
        }
        /* Kaufleiste */
        var lt = q('[data-sf-leiste-text]', root);
        if (lt) lt.textContent = kurz + (gruppen.length && v ? ' · ' + opts.join(' · ') : '');
        var lp = q('[data-sf-leiste-preis]', root); if (lp && v) lp.textContent = geld(v.p * menge);
        var lk = q('[data-sf-leiste-kauf]', root), la = q('[data-sf-leiste-aus]', root);
        if (lk) lk.hidden = !verf; if (la) la.hidden = verf;
      }

      function mengeLesen(klemmen) {
        var n = parseInt(mengeFeld.value, 10);
        if (!(n >= 1)) { if (!klemmen) return; n = 1; }
        n = Math.min(99, n);
        if (klemmen) mengeFeld.value = n;
        menge = n;
        var mw = q('[data-sf-menge]', root);
        if (mw) qa('button[data-d]', mw).forEach(function (b) { var d = Number(b.getAttribute('data-d')); b.disabled = (d < 0 && n <= 1) || (d > 0 && n >= 99); });
        aktualisiere(false);
      }

      root.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('fieldset[data-sf-option] input')) aktualisiere(true);
        if (e.target === mengeFeld) mengeLesen(true);
      });
      root.addEventListener('input', function (e) { if (e.target === mengeFeld) mengeLesen(false); });
      root.addEventListener('click', function (e) {
        var th = e.target.closest('[data-sf-thumb]');
        if (th) { zeigeMedium(th.getAttribute('data-sf-thumb')); return; }
        if (e.target.closest('[data-sf-leiste-kauf]') && form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      });

      /* Kaufleiste (nur Handy sichtbar): erscheint, sobald der Kaufbereich über dem Bildschirm verschwunden ist */
      var leiste = q('[data-sf-leiste]', root), ziel = q('[data-sf-kaufbereich]', root);
      if (leiste && ziel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0]; leiste.classList.toggle('sichtbar', !e.isIntersecting && e.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(ziel);
      }
      aktualisiere(false);
    }

    function alle() { qa('[data-sf-pd]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
    document.addEventListener('shopify:section:load', alle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-warenkorb"]) return;
  try {
    
  (function () {
    'use strict';
    function q(s, r) { return (r || document).querySelector(s); }
    function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function css(s) { return String(s).replace(/(["\\])/g, '\\$1'); }

    var io = null;
    function beobachte(root) {
      if (io) { io.disconnect(); io = null; }
      var leiste = q('[data-sf-wk-leiste]', root), summe = q('.wk-sum', root);
      if (!leiste || !summe || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { leiste.classList.toggle('sichtbar', !e.isIntersecting); }); }, { threshold: 0.35 });
      io.observe(summe);
    }
    function anmelden(root) {
      if (window.SF && SF.korb && root.getAttribute('data-section-id') && SF.korb.sektionen.indexOf(root.getAttribute('data-section-id')) < 0) {
        SF.korb.sektionen.push(root.getAttribute('data-section-id'));
      }
      /* Auf der Warenkorbseite öffnet ein Kauf im Querverkauf nicht die Schublade – die Seite selbst aktualisiert sich */
      if (window.SF && SF.cfg) SF.cfg.schubladeNachAdd = false;
      if (window.sfRegalStatus) window.sfRegalStatus(root);
      beobachte(root);
    }
    function start() {
      var root = q('[data-sf-wk]'); if (!root) return;
      if (window.SF && SF.bereit) anmelden(root); else document.addEventListener('sf:bereit', function () { anmelden(root); }, { once: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', start);

    /* Neu gerenderte Sektion einsetzen, Fokus + Scrollposition erhalten */
    document.addEventListener('sf:korb', function (e) {
      var root = q('[data-sf-wk]'); if (!root) return;
      var html = e.detail && e.detail.abschnitte && e.detail.abschnitte[root.getAttribute('data-section-id')];
      if (!html) return;
      var neu = q('[data-sf-wk]', new DOMParser().parseFromString(html, 'text/html')); if (!neu) return;
      var a = document.activeElement, merk = null, y = window.scrollY;
      if (a && root.contains(a)) {
        var m = a.closest('.menge[data-key]');
        if (m) merk = '.menge[data-key="' + css(m.getAttribute('data-key')) + '"] ' + (a.tagName === 'INPUT' ? 'input' : 'button[data-d="' + a.getAttribute('data-d') + '"]');
        else if (a.hasAttribute('data-sf-wk-sorte')) merk = '[data-sf-wk-sorte][data-key="' + css(a.getAttribute('data-key')) + '"]';
        else if (a.id === 'sf-wk-note') merk = '#sf-wk-note';
      }
      var notizOffen = q('[data-sf-wk-notiz]', root) && q('[data-sf-wk-notiz]', root).open;
      var notizText = q('#sf-wk-note', root) ? q('#sf-wk-note', root).value : null;
      root.innerHTML = neu.innerHTML;
      var nd = q('[data-sf-wk-notiz]', root);
      if (nd && notizOffen) nd.open = true;
      if (notizText !== null && q('#sf-wk-note', root) && document.activeElement && merk === '#sf-wk-note') q('#sf-wk-note', root).value = notizText;
      if (merk) { var el = q(merk, root); if (el) { el.focus({ preventScroll: true }); window.scrollTo(0, y); } }
      if (window.sfRegalStatus) window.sfRegalStatus(root);
      beobachte(root);
    });

    /* Sorte in der Position ändern: neue Variante mit gleicher Menge hinzufügen, alte Zeile entfernen */
    document.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-sf-wk-sorte]'); if (!s || !window.SF) return;
      var key = s.getAttribute('data-key'), menge = Number(s.getAttribute('data-menge')) || 1, neu = s.value;
      if (neu === s.getAttribute('data-aktuell')) return;
      s.disabled = true;
      SF.korb.add(neu, menge, { ohneSchublade: true })
        .then(function () { return SF.korb.entferne(key); })
        .catch(function () { SF.korb.neuLaden().catch(function () {}); });
    });

    /* Anmerkung speichern, sobald das Feld verlassen wird */
    document.addEventListener('focusout', function (e) {
      var n = e.target; if (!n || n.id !== 'sf-wk-note') return;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: n.value }) }).catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
